import { render, staticRenderFns } from "./GenerationHistoryDetailCardConcept.vue?vue&type=template&id=fc68a904"
import script from "./GenerationHistoryDetailCardConcept.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryDetailCardConcept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports